export default {
  helpCenter: 'Central de Ajuda',
  'helpCenter.customerService': 'Atendimento ao Cliente',

  'helpCenter.lastUpdates': 'Últimos Lançamentos',
};
